import { render, staticRenderFns } from "./IpoResultAccountsRow.vue?vue&type=template&id=1bb5bf3f&scoped=true"
import script from "./IpoResultAccountsRow.vue?vue&type=script&lang=js"
export * from "./IpoResultAccountsRow.vue?vue&type=script&lang=js"
import style0 from "./IpoResultAccountsRow.vue?vue&type=style&index=0&id=1bb5bf3f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bb5bf3f",
  null
  
)

export default component.exports